import React from "react";
import Select from "react-select";

const StateSelectUser = ({
  stateList,
  selectedState,
  setSelectedState,
  width = "100%",
}) => {
  const options = [
    { value: "", label: "All States" },
    ...stateList.map((state) => ({
      value: state,
      label: state,
    })),
  ];

  const handleChange = (selectedOptions) => {
    let states = selectedOptions || [];

    if (states.some((s) => s.value === "")) {
      states = [{ value: "", label: "All States" }];
    }

    setSelectedState(states);
  };

  return (
    <div style={{ width }}>
      <Select
        options={options}
        isMulti
        value={selectedState}
        onChange={handleChange}
        placeholder="Select State"
        closeMenuOnSelect={false}
      />
    </div>
  );
};

export default StateSelectUser;
